import { ExtendedTabProps } from "@components/common/tabs/tabs-type";
import { TabsWithRoutes } from "@components/common/tabs/tabs-with-routes";
import { CircularProgress } from "@flat-ui";
import { useHasUserValidFeatureCompanyLevel } from "@hooks/feature-control/use-has-user-valid-feature-company-level";
import { NotFoundPage } from "@pages/not-found-page";
import { ExportWorkspace } from "@pages/settings/export-workspace/export-workspace";
import { GeneralSettings } from "@pages/settings/general-settings/general-settings";
import { SubscriptionSettings } from "@pages/settings/subscription-settings/subscription-settings";
import { SettingsTabs } from "@router/route-params";
import { useAppParams } from "@router/router-helper";
import { RequiredFeatureCompanyLevelName } from "@utils/feature-control/company/company-feature-control-types";
import { OpenTabEvents } from "@utils/track-event/track-event-list";

/** Content in the Workspace Settings page */
export function WorkspaceSettingsPage(): JSX.Element {
  const { settingsTab } = useAppParams();
  const { canExportWorkspace } = useHasUserValidFeatureCompanyLevel();

  if (
    !settingsTab ||
    !Object.values(SettingsTabs).includes(settingsTab)
  ) {
    return <NotFoundPage />;
  }

  const tabs: ExtendedTabProps<SettingsTabs, false>[] = [
    {
      label: "General",
      route: SettingsTabs.general,
      content: () => <GeneralSettings />,
      loadingContent: <CircularProgress />,
    },
    {
      label: "Subscription",
      route: SettingsTabs.subscription,
      content: () => <SubscriptionSettings />,
      loadingContent: <CircularProgress />,
    },
    {
      label: "Export",
      route: SettingsTabs.export,
      content: () => <ExportWorkspace />,
      loadingContent: <CircularProgress />,
      requiredFeatureCompanyLevel: RequiredFeatureCompanyLevelName.canExportWorkspace,
      isHidden: !canExportWorkspace,
    },
  ];

  return (
    <TabsWithRoutes
      dataTestId="WORKSPACE_SETTINGS_CONTAINER"
      selectedTab={settingsTab}
      requiredAttribute={false}
      trackingEventPageName={OpenTabEvents.openWorkspaceSettingsTab}
      tabs={tabs}
    />
  );
}
